import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  .MuiToolbar-root .MuiToolbar-regular .jss22 .MuiToolbar-gutters {
    background: rgb(0, 135, 234);
  }
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body {
    background: #fafafa;
    color: #000;
    -webkit-font-smoothing: antialiased;
  }
  body, input, button {
    font-family: 'Roboto';
    font-size: 16px;
    color: #000;
  }
  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }
  button {
    cursor: pointer;
  }

  ::-webkit-scrollbar {
  width: 10px;
  height: 11px;
}

::-webkit-scrollbar-thumb {
  background: #0091ea; 
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #0064b7; 
}
`;